import { CSSTransition } from "react-transition-group";

export default function ErrorMessage({
  message,
}: {
  message: string;
}): React.ReactElement {
  return (
    <CSSTransition
      in={Boolean(message)}
      timeout={200}
      classNames="errorDisplay"
    >
      <span>{message}</span>
    </CSSTransition>
  );
}
